const initialState = {
  isFetchingUsersID: false,
  divorcesList: [],
};

const LandingPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_USER_ID":
      return { state, isFetchingUsersID: true };
    case "SUCCESS_USER_ID":
      return {
        state,
        divorcesList: action.payload.data,
        isFetchingUsersID: false,
      };
    case "ERROR_USER_ID":
      return { state, isFetchingUsersID: false };

      case "SUCCESS_DELETE_DIVORCE":
        return { state, isFetchingUsersID: false , divorcesList: state.divorcesList.filter( divorce => divorce.divorce_id !== action.payload.divorce_id)  };
       
        case "ERROR_DELETE_DIVORCE":
        return { state, isFetchingUsersID: false };
  
    default:
      return state;
  }
};

export default LandingPageReducer;
